var Handlebars = require("/home/dmitra/dev/contrail-charts/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div component=\"compositey-id1\" class=\"col-md-12\"></div>\n<div component=\"compositey-id2\" class=\"col-md-12\"></div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./examples/linebar-chart/tooltip/template.html
// module id = 50
// module chunks = 0